import React, { Component } from 'react'
import ListadoPage from '../../containers/page/ListadoPage'
import SimpleModalPage from '../../containers/comun/modal/SimpleModalPage'
import MensajeAlertaPage from '../../containers/comun/mensajeAlerta/MensajeAlertaPage'
import FiltrosSeguimientoPage from '../../containers/seguimiento/FiltrosSeguimientoPage'
import ModalNuevoMagavisionPage from '../../containers/analisisExtracciones/ModalNuevoMagavisionPage'
import ModalListadoSeguimientoPage from '../../containers/seguimiento/ModalListadoSeguimientoPage'
import ModalFormSeguimientoPage from '../../containers/seguimiento/ModalFormSeguimientoPage'
import ModalContajeMaquinasPage from '../../containers/analisisExtracciones/ModalContajeMaquinasPage'
import { date_parser, dateTimeZones } from '../../util/formatFunctions'
import {permisos as permisosConstant} from '../../constants/permisos'
import {tipoAnalisisControlMorfologicoSeguimiento as tipo} from '../../constants/comun'
import ModalInicioNuevoSeguimientoPage from '../../containers/seguimiento/ModalInicioNuevoSeguimientoPage'

class Seguimiento extends Component {
  componentDidMount () {
    this.props.actions.comboOperario()
    document.title = this.props.t('MENU.EXTRACCIONES.SEGUIMIENTO') + ' - ' + this.props.t('HEADER.TITLE_GESIPOR')
    let fechaActual = date_parser(dateTimeZones(this.props.auth.zonaHorariaString), this.props.auth.formaFechaHora)
    this.props.actions.fetchSeguimientos({fechaDesde: fechaActual, 'seleccionar-todo': false/*, tipo: {value: 1, label: this.props.t('COMUN.COMBOS.VERRACO_POOL.VERRACO')}*/})
    this.props.actions.fetchPanelControl()
  }

  render () {
    const {
      mainList = [], checkedFiltrosSeguimiento, t, numeroRegistrosPorPagina, paginaActual, modalFormSeguimiento: {data},
      actions: {openModalFormSeguimiento, openModalListadoSeguimiento, deleteSeguimiento}
    } = this.props

    const tKey = 'SEGUIMIENTO.'
    const idElemento = 'idSeguimiento'
    const idForm = 'seguimientoTable'
    
    const tableSeguimiento = {
      id: 'seguimientoTable',
      form: idForm,
      multiHeader: false,
      hasCheckbox: (this.props.auth.permisos === '-1' || this.props.auth.permisos[permisosConstant.SEGUIMIENTO] > 1),
      idElemento,
      hasOptions: true,
      mostrarModificar: true,
      onEdit: (row) => openModalFormSeguimiento(row.idSeguimiento, false, !!row.idPool),
      mostrarDuplicar: (this.props.auth.permisos === '-1' || this.props.auth.permisos[permisosConstant.SEGUIMIENTO] > 1),
      duplicar: (row) => openModalFormSeguimiento(row.idSeguimiento, true, !!row.idPool),
      verDetalle: (row) => openModalListadoSeguimiento(row.idAnalisis, row.idPool),
      mostrarEliminar: (this.props.auth.permisos === '-1' || this.props.auth.permisos[permisosConstant.SEGUIMIENTO] > 1),
      onDelete: (row) => deleteSeguimiento(row),
      vigilado: false,
      mostrarCambiarEyaculadoEliminado: false,
      mostrarCambioEstado: false,
      columns: [
        {id: 'codigo', name: t(tKey + 'COLUMNS.CODIGO'), type: 'numero', numDecimales: 0},
        {id: 'nombreVerracoPool', name: t(tKey + 'COLUMNS.VERRACO_POOL')},
        {id: 'indexVerraco', name: t(tKey + 'COLUMNS.INDEX')},
        {id: 'fechaExtraccion', name: t(tKey + 'COLUMNS.FECHA_EXTRACCION'), type: 'fecha'},
        {id: 'fecha', name: t(tKey + 'COLUMNS.FECHA_SEGUIMIENTO'), type: 'fecha'},
        {id: 'nombreRaza', name: t(tKey + 'COLUMNS.RAZA')},
        {id: 'nombreLinea', name: t(tKey + 'COLUMNS.LINEA_GENETICA')},
        // {id: 'nivelGenetico', name: t(tKey + 'COLUMNS.NIVEL_GENETICO')},//lo quitamos por optimización. Si es necesario ponerlo, habrá que insertar el idNivelGenetico en la tabla de Seguimiento
        {id: 'porMotilidad', name: t(tKey + 'FORM.FORM.MOTILIDAD_PERCENT')},
        {id: 'concentracion', name: t(tKey + 'FORM.FORM.CONCENTRACION')},
        {id: 'formasAnormales', name: t(tKey + 'FORM.FORM.FORMAS_ANORMALES')},
        {id: 'operarioProcesado', name: t('ANALISIS_EXTRACCIONES.FORM.FORM.OPERARIO_PROCESADO')},
        {id: 'tipoControl', name: t(tKey + 'COLUMNS.TIPO_CONTROL')}
      ],
      rows: mainList,
      leyenda: [
        {name: t("ANALISIS_EXTRACCIONES.LEYENDA.PERTENECE_POOL"), color: '#2538aa'},
        {name:  t(tKey + 'COLUMNS.NoAPTO'), color: '#c4415d'}
      ],
      colorearRow: (row) => {        
        let classRow = ''
        if (row.idPool){
          classRow = 'analisis-pertenece-pool'
        }
        if (!row.apto){
          classRow = 'seguimiento-no-apto'
        }        
        return classRow
      },
      filtros: <FiltrosSeguimientoPage idElemento={idElemento} idForm={idForm} />,
      initialValues: {}
    }
    tableSeguimiento.rows.forEach(
      (row, idRow) => {
        if (idRow >= numeroRegistrosPorPagina * (paginaActual - 1) && idRow < numeroRegistrosPorPagina * paginaActual) {
          tableSeguimiento.initialValues['check' + idForm + row[idElemento]] = checkedFiltrosSeguimiento;
        }
      }
    )
    return (
      <div>
        <ModalInicioNuevoSeguimientoPage />
        <ModalNuevoMagavisionPage from={tipo.SEGUIMIENTO} isSeguimiento={true} isFromSeguimientoList={true} />
        <ModalListadoSeguimientoPage renderForm={false} />
        <ModalFormSeguimientoPage />
        <ModalContajeMaquinasPage />
        <SimpleModalPage/>
        <MensajeAlertaPage/>
        <ListadoPage t_key={tKey} table={tableSeguimiento}>
        </ListadoPage>
      </div>
    )
  }
}

export default Seguimiento